import './admin.scss'
import { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import utility from 'src/utils/utility'
import { Header } from 'src/component'
import access from 'src/utils/localAccess'
import { appSettings } from 'src/provider/config/constant'
import { UserType } from 'src/model'

export const AdminRoutes = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { API } = useContext(ApiContext)
    const {info: {authToken, sessionAliveTrigger, sso_token, userType}, recoverStatesData, logout} = useContext(AppInfoContext)
    const [isAuth, setIsAuth] = useState(!!authToken)

    useEffect(() => {
        access.setNavigationAccess(navigate)
        access.setLogoutHandler(logout)
        recoverStatesData()
        handleAuth()
    }, [])

    useEffect(() => {
        if (authToken && sso_token) API.runBackgroundCalls('keep-session-alive', appSettings.TOKEN_REFRESH_TIME)
    }, [sessionAliveTrigger, authToken])

    useEffect(() => {
        if (userType) handleAccess()
    }, [location.pathname, userType])

    async function handleAuth () {
        let [authToken, sessionExpiryTime] = await Promise.all([
            localStorage.getItem('authToken'),
            localStorage.getItem('session-expiry-time')
        ])

        authToken = authToken === 'null' ? null : authToken

        setIsAuth(!!authToken)

        if (!authToken) {
            handleLogout()
        }
    }

    function handleAccess() {
        const userCategory = utility.getUserTypeLabel(utility.toTitleCase(userType))?.toLowerCase()
        //console.log({path: location.pathname, userCategory})

        if (!location.pathname.includes(userCategory)) {
            handleLogout()
        }
    }

    async function handleLogout () {
        await logout()
        navigate('/')
    }
    
    return (
        <>
            { isAuth &&
                <div className="admin-container">
                    <Header />
                    <div className="admin-modules">
                        <Outlet/>
                    </div>
                </div>
            }
        </>
    )
}

export default utility.routeData('admin', 'Admin', <AdminRoutes/>)
